<template>
  <div class="orderOut_content">
      <div class="title">{{title}}信息{{index+1}}</div>
      <div class="content">
        <a-descriptions >
          <a-descriptions-item :label="title+ '单号'" >
            <span v-if="orderDetail.isWarehouseMultiDischargeOrder">
              {{warehouseOrderResList.wmsOdrNo?warehouseOrderResList.wmsOdrNo:''}}
            </span>
            <span v-else>
              {{(warehouseOrderResList.ext && warehouseOrderResList.ext.warehouseOdrNo) || ''}}
            </span>
          </a-descriptions-item>
          <a-descriptions-item label="仓库">
            {{orderDetail.ext && orderDetail.ext.demoData ? '运荔枝演示仓库'  :warehouseOrderResList.warehouseName}}
          </a-descriptions-item>
          <a-descriptions-item label="状态">
            {{warehouseType[warehouseOrderResList.status]}}
          </a-descriptions-item>
          <a-descriptions-item label="创建时间">
            {{filterTime(warehouseOrderResList.createTime)}}
          </a-descriptions-item>
          <a-descriptions-item label="更新时间">
            {{filterTime(warehouseOrderResList.updateTime)}}
          </a-descriptions-item>
        </a-descriptions>
        <slot name="info"></slot>
        <NowwaWareDetailTable  v-if="isNowWaCustomer&&title === orderType.RK" :receipt-order-no=" warehouseOrderResList.ext.warehouseOdrNo" />
        <div v-else >
           <a-table
          :columns="title === orderType.CK ? goodsTableColums : goodsTableColumsIn"
          :data-source="tableData"
          :pagination="false"
          :custom-row="customRow"
          size="middle"
          :row-class-name="(_record, index) => (index % 2 === 1 ? null : 'table-striped')"
          class="goods-table">
          <template slot="stockCondition" slot-scope="text, row">
            <div v-if="row.wmsExt">
              <p v-if="row.wmsExt.batchAttr && row.wmsExt.batchAttr.length">
                {{row.wmsExt.batchAttr[0].attrName}}:{{row.wmsExt.batchAttr[0].attrValue}}
              </p>
              <p v-if="row.wmsExt.storehouseId">
                指定库位:{{row.wmsExt.storehouseCode}}
              </p>
              <p v-if="row.wmsExt.designatedGoodsQuality">
                货品质量:{{getQuality(row.wmsExt.designatedGoodsQuality)}}
              </p>
            </div>
          </template>
        </a-table>
        </div>
      </div>
  </div>
</template>

<script>
import moment from 'moment'
import { goodsQuality } from '../../warehouseCreate/goodsTable'
import NowwaWareDetailTable from './nowwaWareDetailTable.vue'

const warehouseType = {
  DELIVER_DRAFT: "出库草稿",
  DELIVERING: "出库中",
  DELIVER_FINISH: "出库完成",
  STORE_DRAFT: "入库草稿",
  STORING: "入库中",
  STORE_FINISH: "入库完成",
  CANCEL: "取消"
}
const orderType = {
  CK: '出库',
  RK: '入库',
  DB: '调拨',
}
  export default {
    name:'OrderOutData',
    components:{
      NowwaWareDetailTable
    },
    props:{
      index:{
        type:Number,
        default:1
      },
      dispatchList:{
        type:Array,
        default:()=>[]
      },
      orderDetail:{
        type:Object,
        default:()=>{}
      },
      title:{
        type:String,
        default:''
      },
      warehouseOrderResList:{
        type:Object,
        default:()=>{}
      },
      tableData:{
        type:Array,
        default:()=>[]
      },
      isNowWaCustomer:{
        type:Boolean,
        default:false
      }
    },
    data(){
      return{
        warehouseType,
        orderType,
        goodsTableColums: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          width: 60,
          scopedSlots: { customRender: 'indexNum' },
          customRender: (value, row) => {
            return {
                children: value,
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
          },
        },
        {
          title: '货品',
          dataIndex: 'skuName',
          key: 'skuName',
          width: 200,
          customRender: (value, row) => {
            return {
                children: value,
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
          },
        },
        {
          title: '指定条件',
          dataIndex: 'stockCondition',
          key: 'stockCondition',
          width: 100,
          scopedSlots: { customRender: 'stockCondition' },
        },
        {
          title: '计划量',
          dataIndex: 'planAmount',
          key: 'planAmount',
          width: 100,
          customRender: (value, row) => {
            return {
                children: value !== null ? `${value}${row.wmsExt?.goodsUnit || row.wmsExt?.goodUnit || '--'}` : '',
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
          },
        },
        {
          title: `出库量`,
          dataIndex: 'finishAmount',
          key: 'finishAmount',
          width: 100,
          customRender: (value, row) => {
            return {
                children: value !== null ? `${value}${row.wmsExt?.goodsUnit || row.wmsExt?.goodUnit || '--'}` : '',
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
          },
        },
        ],
        goodsTableColumsIn: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          width: 60,
          scopedSlots: { customRender: 'index' },
          customRender: (value, row) => {
            return {
                children: value,
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
          },
        },
        {
          title: '货品',
          dataIndex: 'skuName',
          key: 'skuName',
          width: 200,
          customRender: (value, row) => {
            return {
                children: value,
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
          },
        },
        // {
        //   title: '指定批次',
        //   dataIndex: 'stockBatch',
        //   key: 'stockBatch',
        //   width: 100
        // },
        {
          title: '生产日期',
          dataIndex: 'productDate',
          key: 'productDate',
          width: 100,
          customRender: (value, row) => {
            const { batchAttr } = row.wmsExt || {}
            if (batchAttr?.length) {
              const date = batchAttr.find(item => item.attrCode === 'productDate')
              return date?.attrValue || '--'
            }
            return '--'
          }
        },
        {
          title: '计划量',
          dataIndex: 'planAmount',
          key: 'planAmount',
          width: 100,
          customRender: (value, row) => {
            return {
                children: value !== null ? `${value}${row.skuUnit || '--'}` : '',
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
          },
        },
        {
          title: `入库量`,
          dataIndex: 'finishAmount',
          key: 'finishAmount',
          width: 100,
          customRender: (value, row) => {
            return {
                children: value !== null ? `${value}${row.skuUnit || '--'}` : '',
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
          },
        },
        ],
      }
    },
    computed:{
      filterTime(){
        return(time)=>{
         return moment(time).format('YYYY-MM-DD HH:mm:ss')
        }
      }
    },
    methods:{
      getQuality(quality) {
        const current = goodsQuality.find(item => item.value === quality)
        return current?.label || '--'
      },
      // rowClass(record) {
      //   return `rowSpan${record.skuId}${this.index}`;
      // },
      customRow() {
        return {
          on: {
            mouseenter: (event) => {
              this.mouseAction(event, 'add');
            },
            mouseleave: (event) => {
              this.mouseAction(event, 'remove');
            },
          }
        };
      },
      mouseAction(event, type) {
      const { classList } = event.target;
      let currentClass = '';
      for (let i = 0; i < classList.length; i+=1) {
        if (/rowSpan+/.test(classList[i])) {
          currentClass = classList[i];
          break;
        }
      }
      const eles = document.getElementsByClassName(currentClass);
      for (let i = 0; i < eles.length; i+=1) {
        eles[i].classList[type]('ant-table-row-hover');
      }
    },
    }
  }
</script>

<style lang="less" scoped>
.orderOut_content{
  .content{
    padding: 16px 24px;
    border:1px solid #F5F5F6;
    ::v-deep  .ant-descriptions{
      border-bottom: 1px solid #D9DBDE;
      margin-bottom: 24px;
      .ant-descriptions-view{
        margin-bottom: 16px;
      }
      .ant-descriptions-item{
        padding-bottom: 0;
        .ant-descriptions-item-label,
        .ant-descriptions-item-content{
          padding: 8px 0px;
        }
      }
    }
  }
  .title{
    background: #F0F2F5;
    border-radius: 4px 4px 0px 0px;
    height: 40px;
    line-height: 40px;
    padding-left: 24px;
    font-size: 14px;
    color: #404B5C;
  }
}
::v-deep .goods-table  {
  .table-striped td{
    background-color: #fafafa;
  }
  .ant-table-thead{
        th{
          background: #fff !important;
        }
      }
}
</style>